import { render, staticRenderFns } from "./updateCont.vue?vue&type=template&id=e98f1956&"
import script from "./updateCont.vue?vue&type=script&lang=js&"
export * from "./updateCont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports